export class FetchService {
    cache = false;

    setCache(value){
        this.cache = value;
    }

    async loadJSONFile(path, options = {}) {
        const {
            cache = this.cache,
            fallback = null
        } = options;

        if (!path || typeof path !== 'string') {
            return fallback;
        }

        const url = this.buildUrl(path, cache);

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            return await response.json();

        } catch (error) {
            return fallback;
        }
    }

    async postJSON(path, body = {}, options = {}) {
        const {
            fallback = [],
            headers = {}
        } = options;

        if (!path || typeof path !== 'string') {
            return fallback;
        }

        try {
            const response = await fetch(path, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    ...headers
                },
                body: typeof body === 'string'
                    ? body
                    : JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            return await response.json();

        } catch (error) {
            console.warn('FetchService postJSON error:', {
                path,
                error
            });

            return fallback;
        }
    }

    buildUrl(path, cache = false) {
        if (cache) {
            return path;
        }

        const separator = path.includes('?') ? '&' : '?';
        return `${path}${separator}v=${Date.now()}`;
    }
    
    async get(path, options = {}) {
        return await this.request(path, { method: 'GET', ...options });
    }

    async post(path, body = {}, options = {}) {
        return await this.request(path, {
        method: 'POST',
        body: JSON.stringify(body),
        ...options
        });
    }

    async put(path, body = {}, options = {}) {
        return await this.request(path, {
        method: 'PUT',
        body: JSON.stringify(body),
        ...options
        });
    }

    async delete(path, options = {}) {
        return this.request(path, { method: 'DELETE', ...options });
    }
    
    async request(path, options = {}) {
        const config = {
        ...options
        };

        try {
        const response = await fetch(path, config);

        const contentType = response.headers.get('content-type') ?? '';

        let data = null;

        if (contentType.includes('application/json')) {
            data = await response.json();
        } else {
            data = await response.text();
        }

        if (!response.ok) {
            console.error('Error HTTP:', {
            status: response.status,
            statusText: response.statusText,
            data
            });

            return {
            ok: false,
            status: response.status,
            error: data,
            content: null
            };
        }

        return {
            ok: true,
            status: response.status,
            error: null,
            content: data
        };

        } catch (error) {
        console.error('Error de conexión o fetch:', error);

        return {
            ok: false,
            status: 0,
            error,
            content: null
        };
        }
    }

    async getJSON(path, options = {}) {
        const {
            fallback = [],
            headers = {}
        } = options;

        if (!path || typeof path !== 'string') {
            return fallback;
        }

        const url = this.buildUrl(path, false);

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    ...headers
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            return await response.json();

        } catch (error) {
            return fallback;
        }
    }
}